/**
 * Painel 360° (/dashboard-vendas, papel Painel de Metas).
 * Grupos de rollout: a partir de `rolloutStartDate` (YYYY-MM-DD, inclusivo, fuso do navegador),
 * os `cores` daquele grupo podem ver o painel (além da role DASHBOARD_VENDAS).
 * Calendário: março/abril de 2026.
 */

/** @type {Array<{ rolloutStartDate: string; cores: string[] }>} */
export const PAINEL360_ROLLOUT_GROUPS = [
  {
    rolloutStartDate: '2026-03-31',
    cores: [
      'nuc ribeirao preto dom',
      'nuc bauru dom',
      'nuc curitiba dom',
      'nuc londrina dom',
      'nuc pe dom',
      'nuc porto alegre dom',
      'nuc salvador dom',
      'nuc se dom',
      'nuc sul ba dom',
    ],
  },
  {
    rolloutStartDate: '2026-04-14',
    cores: [
      'nuc juazeiro ba dom',
      'nuc ms dom',
      'nuc santos dom',
      'nuc paulinia dom',
      'nuc maranhao dom',
      'nuc esp santo dom',
      'nuc santa maria dom',
      'nuc al dom',
      'nuc df dom',
      'nuc mt dom',
      'nuc oeste dom',
      'nuc oeste mg dom',
    ],
  },
  {
    rolloutStartDate: '2026-04-21',
    cores: [
      'nuc rnpb dom',
      'nuc go dom',
      'nuc leste gru dom',
      'nuc sorocaba dom',
      'nuc para dom',
      'nuc piaui dom',
      'nuc grande bh dom',
      'nuc santa catarina dom',
    ],
  },
  {
    rolloutStartDate: '2026-04-28',
    cores: [
      'nuc norte ba dom',
      'nuc ceara dom',
      'nuc to dom',
      'nuc abc e centro dom',
      'nuc sao jose dos campos dom',
      'nuc grande rio dom',
      'nuc nordeste mg dom',
    ],
  },
];

/**
 * @param {string | null | undefined} raw
 */
export function normalizeCore(raw) {
  if (raw == null || typeof raw !== 'string') return '';
  return raw
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
    .replace(/-/g, ' ')
    .replace(/\s+/g, ' ');
}

function todayYmd() {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

/**
 * Libera se o núcleo está em algum grupo cuja data de rollout já passou (hoje >= rolloutStartDate).
 */
export function isPainel360Allowed() {
  const coreNow = normalizeCore(localStorage.getItem('core'));
  if (!coreNow) return false;

  const hoje = todayYmd();

  return PAINEL360_ROLLOUT_GROUPS.some(group => {
    if (hoje < group.rolloutStartDate) return false;
    return group.cores.some(c => normalizeCore(c) === coreNow);
  });
}
